<header>
  <!-- Logo Section -->
  <div class="logo-container">
    @if (isPublicView()) {
      <svg-icon src="assets/logo.svg" />
    } @else {
      <button type="button" class="btn btn-icon" (click)="onLogoClick()">
        <svg-icon src="assets/logo.svg" />
      </button>
    }
  </div>

  @if (isPublicView()) {
    <div class="flex-1"></div>
  } @else {
    <!-- Navigation Section (only for authenticated users) -->
    <nav class="d-flex gap-2 flex-1">
      @for (item of navItems(); track item.label) {
        <a
          [routerLink]="item.route"
          routerLinkActive="active"
          class="nav-item"
          [routerLinkActiveOptions]="{ exact: item.exact ?? false }">
          {{ item.label }}
        </a>
      }
    </nav>
  }

  <!-- Actions Section -->
  @if (isTemporaryUser()) {
    <!-- Guest User Actions -->
    <div class="d-flex gap-3 align-items-center">
      <div class="d-flex align-items-center gap-2">
        <custom-icon name="clock" [size]="20" />
        <span>{{ expirationMessage() }}</span>
      </div>
      <button type="button" class="btn btn-sm btn-info" (click)="onSignUpClick()">Sign up for free</button>
    </div>
  } @else {
    <!-- Regular User Actions -->
    <div class="d-flex gap-1 align-items-center">
      @if (isPublicView()) {
        <!-- Public View Actions: Just sign up button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="onSignUpClick()">Sign up for free</button>
      } @else {
        @if (showUpgradeButton()) {
          <button type="button" class="btn btn-sm btn-info icon-with-text" (click)="onSignUpClick()">
            <custom-icon name="upgrade" [size]="20" />
            <span>Upgrade</span>
          </button>
        }
        
        <component-notifications />

        @if (isImpersonating()) {
          <button type="button" class="btn btn-sm btn-danger ms-2" (click)="onStopImpersonating()">Stop Impersonating</button>
        }

        <!-- User Profile Popup -->
        <component-user-profile-popup />
      }
    </div>
  }
</header>
